/** @format */

import { User } from "lucide-react";

export default function AccountSettings() {
  return (
    <div className="space-y-6 h-full">
      <div className="flex items-center gap-3">
        <User className="w-10 h-10 text-blue-400" />
        <div>
          <h1 className="text-2xl font-bold text-white">Account</h1>
          <p className="text-slate-400 text-sm">
            Manage your profile and security settings.
          </p>
        </div>
      </div>
      <div className="rounded-xl border border-slate-600/50 bg-slate-800/30 p-8 text-center">
        <p className="text-slate-400">Account settings coming soon.</p>
      </div>
    </div>
  );
}
